import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
export class YinshScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        return node.gameState.sideRings.toTable();
    }
}
